export function DonationImage() {
    return <div dangerouslySetInnerHTML={{ __html: "<a href='https://ko-fi.com/P5P89LB6I' target='_blank'><img height='36' style='border:0px;height:36px;' src='https://cdn.ko-fi.com/cdn/kofi2.png?v=3' border='0' alt='Buy Me a Coffee at ko-fi.com' /></a>" }} />;
}
